import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../../FaIcon';

export function McpUpgradeHero() {
    const { t } = useTranslation();

    return (
        <div className="upgrade-hero">
            <div className="upgrade-hero-badge">
                <FaIcon iconName="plug" />
                <span>{t('mcp_upgrade.hero.badge')}</span>
            </div>
            <h1 className="upgrade-hero-title">{t('mcp_upgrade.hero.title')}</h1>
            <p className="upgrade-hero-subtitle">{t('mcp_upgrade.hero.subtitle')}</p>
        </div>
    );
}
